/**
 * Funções de filtro das tabelas (TanStack Table).
 * Valores de filtro "lista" são sempre strings (toListKey) para caberem na URL.
 */
export const toListKey = (value) => (value === null || value === undefined ? "" : String(value));

export const normalizeText = (value) =>
    String(value ?? "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

/** Dia local no formato YYYY-MM-DD (mesmo dia exibido na célula). */
export const toDayKey = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
};

export const inList = (row, columnId, filterValue) =>
    filterValue.includes(toListKey(row.getValue(columnId)));
inList.autoRemove = (value) => !Array.isArray(value) || value.length === 0;

export const dateRange = (row, columnId, filterValue) => {
    const day = toDayKey(row.getValue(columnId));
    if (!day) return false;
    if (filterValue.from && day < filterValue.from) return false;
    if (filterValue.to && day > filterValue.to) return false;
    return true;
};
dateRange.autoRemove = (value) => !value || (!value.from && !value.to);

export const textContains = (row, columnId, filterValue) =>
    normalizeText(row.getValue(columnId)).includes(normalizeText(filterValue).trim());
textContains.autoRemove = (value) => !String(value ?? "").trim();

/** Resultado da busca por texto do servidor: só as linhas cujos ids vieram na resposta. */
const idSets = new WeakMap();
const idSetOf = (filterValue) => {
    let set = idSets.get(filterValue);
    if (!set) {
        set = new Set(filterValue.ids);
        idSets.set(filterValue, set);
    }
    return set;
};
export const inIds = (row, columnId, filterValue) =>
    idSetOf(filterValue).has(toListKey(row.getValue(columnId)));
inIds.autoRemove = (value) => !value || !Array.isArray(value.ids);

const onlyDigits = (value) => String(value ?? "").replace(/\D/g, "");

/** Filtro por dígitos (CPF, telefone): ignora máscara de ambos os lados. */
export const digitsContains = (row, columnId, filterValue) =>
    onlyDigits(row.getValue(columnId)).includes(onlyDigits(filterValue));
digitsContains.autoRemove = (value) => !onlyDigits(value);
